import { defineStore } from "pinia";
import { ref } from "vue";

export interface ActiveDashboardTab {
  pk: number;
  index: number;
  name: string;
}

// The tab the dashboard editor has open. The editor keeps its current tab to
// itself rather than in the URL, so `?tab=` stays whatever the dashboard was
// opened with, and the AI was told about that tab instead of this one.
export const useActiveDashboardTabStore = defineStore(
  "activeDashboardTab",
  () => {
    const active = ref<ActiveDashboardTab | null>(null);

    function setActive(tab: ActiveDashboardTab | null): void {
      active.value = tab;
    }

    return { active, setActive };
  },
);
